export const PANORAMA_MOBILE_HFOV = 50;
export const PANORAMA_DESKTOP_HFOV = 93;
export const PANORAMA_ANIMATION_DURATION = 750;

export const PANNELLUM_CONFIG = {
  type: 'equirectangular',
  autoLoad: true,
  mouseZoom: false,
  disableKeyboardCtrl: true,
  doubleClickZoom: false,
  showControls: false,
  hfov: PANORAMA_DESKTOP_HFOV,
  minHfov: PANORAMA_MOBILE_HFOV,
  maxHfov: PANORAMA_DESKTOP_HFOV,
  dragConfirm: 'both',
};

export const PANNELLUM_ABOUT_MSG_CLASS_SELECTOR = '.pnlm-about-msg';
export const PANNELLUM_UI_CLASS_SELECTOR = '.pnlm-ui';
export const PANNELLUM_CONTAINER_CLASS_SELECTOR = '.pnlm-render-container';
export const PANNELLUM_MESSAGE_CONTAINER_SELECTOR = '.pnlm-interaction-msg';
export const PANNELLUM_MESSAGE_CONTAINER_SELECTORS = [
  PANNELLUM_ABOUT_MSG_CLASS_SELECTOR,
  PANNELLUM_MESSAGE_CONTAINER_SELECTOR,
];
export const PANNELLUM_MESSAGE_SHOWN_EVENT = 'messageshown';
export const PANNELLUM_MESSAGE_CLEARED_EVENT = 'messagecleared';

// HotspotSimple specific
export const HOTSPOTSIMPLE_SIDEPANEL_CLOSE_EVENT = 'sidepanel-close-click';
export const HOTSPOTSIMPLE_SIDEPANEL_LEFT_EVENT = 'sidepanel-left-click';
export const HOTSPOTSIMPLE_SIDEPANEL_RIGHT_EVENT = 'sidepanel-right-click';
export const HOTSPOTSIMPLE_SIDEPANEL_MOUNTED_EVENT = 'sidepanel-mounted';

// Sidepanel mobile slider specific
export const HOTSPOT_SIDEPANEL_MOBILE_SLIDER_INNER_CLASS = '.wb-slider__inner';
export const HOTSPOT_SIDEPANEL_MOBILE_SLIDER_ITEM_CLASS = '.wb-slider__item';
